module.exports = __webpack_public_path__ + "static/img/far2_active.3994cd07.png";